import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './gallery.css';
import { 
  Area1, 
  Area2, 
  Area3, 
  Area4,
  brand_logo
} from '../../assets/images/images';

const Gallery = () => {
  const navigate = useNavigate();

  // Auto-scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBookAppointment = () => {
    navigate('/');
    // Scroll to search container after navigation
    setTimeout(() => {
      const searchContainer = document.querySelector('.search-container');
      if (searchContainer) {
        searchContainer.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
      }
    }, 100);
  };

  const galleryImages = [
    {
      id: 1,
      src: Area1,
      alt: "Modern Waiting Area",
      title: "Modern Waiting Area",
      description: "Comfortable and welcoming space for our patients"
    },
    {
      id: 2,
      src: Area2,
      alt: "Children's Play Area",
      title: "Children's Play Area",
      description: "Kid-friendly environment to make dental visits enjoyable"
    },
    {
      id: 3,
      src: Area3,
      alt: "Treatment Room 1",
      title: "Treatment Room 1",
      description: "State-of-the-art dental treatment facility"
    },
    {
      id: 4,
      src: Area4,
      alt: "Treatment Room 2",
      title: "Treatment Room 2",
      description: "Advanced dental care with modern equipment"
    }
  ];

  return (
    <div className="gallery-page">
      {/* Header */}
      <header className="gallery-header">
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo-link">
              <img src={brand_logo} alt="Shirkande Clinic" className="logo" />
            </Link>
            <h1 className="page-title">Our Clinic Gallery</h1>
            <Link to="/" className="back-home">← Back to Home</Link>
          </div>
        </div>
      </header>

      {/* Gallery Content */}
      <div className="gallery-content">
        <div className="container">
          {/* Gallery Introduction */}
          <div className="gallery-intro">
            <h2>Welcome to Our Modern Dental Clinic</h2>
            <p>Take a virtual tour of our state-of-the-art facilities designed with your comfort and care in mind. Our clinic combines modern technology with a warm, welcoming atmosphere to ensure the best dental experience.</p>
          </div>

          {/* Image Grid */}
          <div className="gallery-grid">
            {galleryImages.map((image) => (
              <div key={image.id} className="gallery-item">
                <div className="image-container">
                  <img src={image.src} alt={image.alt} />
                  <div className="image-overlay">
                    <h4>{image.title}</h4>
                    <p>{image.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="gallery-cta">
            <h3>Ready to Experience Our Clinic?</h3>
            <p>Book your appointment today and see our facilities in person</p>
            <button onClick={handleBookAppointment} className="cta-button">Book Appointment</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
